export default function Rules() {
  return (
    <>Rules</>
  )
}
